export default function QuestionMark() {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M39.6111 42.2234L44.8486 47.4591C45.5686 48.1791 46.7391 48.1791 47.4591 47.4591C48.1791 46.7391 48.1791 45.5686 47.4591 44.8486L42.2234 39.6111C45.8234 35.4148 48 29.9594 48 24C48 10.7538 37.2461 0 24 0C10.7538 0 0 10.7538 0 24C0 37.2461 10.7538 48 24 48C29.9594 48 35.4148 45.8234 39.6111 42.2234ZM24 36.9231C25.2738 36.9231 26.3077 37.9569 26.3077 39.2308C26.3077 40.5046 25.2738 41.5385 24 41.5385C22.7262 41.5385 21.6923 40.5046 21.6923 39.2308C21.6923 37.9569 22.7262 36.9231 24 36.9231ZM16.6154 18.4615C16.6154 14.3852 19.9237 11.0769 24 11.0769C28.0763 11.0769 31.3846 14.3852 31.3846 18.4615C31.3846 22.5378 28.0763 25.8461 24 25.8461C22.9809 25.8461 22.1538 26.6732 22.1538 27.6923V31.3846C22.1538 32.4037 22.9809 33.2308 24 33.2308C25.0191 33.2308 25.8461 32.4037 25.8461 31.3846V29.3852C31.0818 28.5046 35.0769 23.9465 35.0769 18.4615C35.0769 12.3489 30.1126 7.38461 24 7.38461C17.8874 7.38461 12.9231 12.3489 12.9231 18.4615C12.9231 19.4806 13.7502 20.3077 14.7692 20.3077C15.7883 20.3077 16.6154 19.4806 16.6154 18.4615Z'
        fill='currentColor'
      />
    </svg>
  )
}
